export default __webpack_public_path__ + "static/heroSectionBg-328406d31e9a14d415c09b0864a1f246.png";